/**
 * Servicio de embarques: CRUD contra la API de Express.
 */
import { apiRequest } from '@/services/apiClient';

export interface Embarkation {
    id: number;
    nombre: string;
    activo: boolean;
}

interface EmbarkationsResponse {
    success: boolean;
    embarkations: Embarkation[];
}

interface CreateEmbarkationResponse {
    embarkation: Embarkation;
}

export const embarkationsService = {
    getAll: async (): Promise<Embarkation[]> => {
        const data = await apiRequest<EmbarkationsResponse>('/embarkations');
        return data.embarkations || [];
    },

    create: async (nombre: string): Promise<Embarkation> => {
        const data = await apiRequest<CreateEmbarkationResponse>('/embarkations', {
            method: 'POST',
            body: { nombre },
        });
        return data.embarkation;
    },

    remove: async (id: number): Promise<void> => {
        await apiRequest(`/embarkations/${id}`, { method: 'DELETE' });
    },
};
